import React, { useEffect } from "react";
import TestimonialSlider from "../components/Testimonial_slider/TestimonialSlider";
import Home from "../components/Home/Home";
import Footer from "../components/Footer/Footer";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

const Homepage = () => {
  const navigate = useNavigate();
  const [cookies] = useCookies(["username", "o1HybridUser"]);
  useEffect(() => {
    if (cookies.o1HybridUser) {
      navigate("/home");
    }
  }, []);

  return (
    <>
      <div
        style={{
          backgroundColor: "#0b001a",
          scrollBehavior: "smooth",
          userSelect: "none",
        }}
      >
        <Home />
        <TestimonialSlider />
        <Footer />
      </div>
    </>
  );
};

export default Homepage;
